<template>
  <v-btn v-bind="{ [size]: true, ...$attrs }" icon v-on="$listeners">
    <v-icon v-bind="{ [size]: true }">mdi-information-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['x-small', 'small', 'medium', 'large', 'x-large'].includes(value),
    },
  },
}
</script>
<style>
v-btn {
  z-index: 9999;
}
</style>
